var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRulerMeasure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ruler-measure",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 12c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12v2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12v3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12v3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12v3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12v2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3v4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5h18"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3v4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerMeasure);
export default __webpack_public_path__ + "static/media/ruler-measure.381034d9.svg";
export { ForwardRef as ReactComponent };